// src/utils/rulePlans/s3RulePlans.js
// S3-specific remediation plan helpers.

export function isS3Rule(ruleId = "") {
  return String(ruleId || "").toUpperCase().includes("S3");
}

export function buildS3FixPlanSteps(item = {}) {
  const rule = String(item?.rule_id || item?.ruleId || "").toUpperCase();

  if (rule.includes("S3_PUBLIC_ACCESS_BLOCK")) {
    return [
      "Open Amazon S3.",
      "Open the affected bucket.",
      "Go to Permissions.",
      "Open Block public access settings.",
      "Enable the required Block Public Access options unless a documented exception exists.",
      "Save changes and review bucket policy/ACLs for public exposure.",
      "Document any approved exception in OASYS.",
      "Run Full Cloud Assessment to verify public access blocking is detected.",
    ];
  }

  if (rule.includes("S3_POLICY_PUBLIC")) {
    return [
      "Open Amazon S3.",
      "Open the affected bucket.",
      "Go to Permissions.",
      "Open Bucket policy.",
      "Remove public principals such as '*' unless formally approved.",
      "Replace broad public access with least-privilege principals and conditions.",
      "Save the policy and document any approved exception.",
      "Run Full Cloud Assessment to verify the public policy finding is cleared.",
    ];
  }

  if (rule.includes("S3_VERSIONING")) {
    return [
      "Open Amazon S3.",
      "Open the affected bucket.",
      "Go to Properties.",
      "Find Bucket Versioning.",
      "Choose Edit and enable versioning.",
      "Save changes.",
      "Confirm lifecycle and retention expectations match the governing SOP.",
      "Run Full Cloud Assessment to verify versioning is detected.",
    ];
  }

  if (rule.includes("S3_ENCRYPTION")) {
    return [
      "Open Amazon S3.",
      "Open the affected bucket.",
      "Go to Properties.",
      "Find Default encryption.",
      "Choose Edit and enable server-side encryption using the approved key strategy.",
      "Save changes and confirm new objects will be encrypted by default.",
      "Review any exception requirements for existing objects.",
      "Run Full Cloud Assessment to verify encryption is detected.",
    ];
  }

  if (rule.includes("S3_LOGGING")) {
    return [
      "Open Amazon S3.",
      "Open the affected bucket.",
      "Go to Properties.",
      "Find Server access logging.",
      "Choose Edit and enable logging or confirm the approved logging alternative.",
      "Select the approved destination bucket/prefix.",
      "Save changes and confirm log delivery expectations.",
      "Run Full Cloud Assessment to verify logging evidence is refreshed.",
    ];
  }

  return null;
}

export function buildS3ValidationText() {
  return "OASYS will mark this improved after the next sync detects the bucket configuration matches the expected control state.";
}
